import React, { ReactElement, ReactNode } from 'react';

interface IInfoBox {
  icon?: ReactNode | ReactElement;
  children: ReactNode;
  'data-testid'?: string;
  className?: string;
}

const InfoBox = (props: IInfoBox) => {
  return (
    <div
      data-testid={props['data-testid']}
      className={`w-full bg-gray-100 p-4 sm:p-6 text-sm sm:text-base sm:font-normal text-left font-medium leading-5 rounded-lg text-primary-2 ${props.className}`}
    >
      <div className="mb-2">{props.icon}</div>
      {props.children}
    </div>
  );
};

export default InfoBox;
